<template>
  <div>
    <nav
      class="navbar navbar-expand-sm shadow p-3 mb-5 bg-white rounded"
      style="height: 5em; margin-bottom: 2em !important"
    >
      <a class="navbar-brand" href="#">
        <span style="font-size: 1.5rem; font-weight: bold; color: #15356f"
          >Brightstar DST</span
        >
      </a>
      <h6 style="margin-bottom: 0">
        Retail Number: <b>{{ $route.params.retailId }}</b>
      </h6>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </nav>
    <div class="content">
      <div style="text-align: center; padding-bottom: 2%">
        <h1
          style="
            font-size: 4rem;
            font-weight: bold;
            color: #f3711d;
            text-shadow: 0px 3px 3px gray;
          "
        >
          Retail Terminal
        </h1>
      </div>
      <div style="padding: 1em">
        <div v-if="isLoading" class="text-center py-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <table
          v-else
          class="table table-striped table-bordered"
          style="background-color: #fff"
        >
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Ticket Id</th>
              <th scope="col">Status</th>
              <th scope="col">Type</th>
              <th scope="col">Price</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="{ deleting: item.isDeleted }"
              v-for="item in myList"
              :key="item.id"
            >
              <td width="10%">
                <img
                  v-if="item.type"
                  width="150px"
                  :src="`/game-image/${item.type}/thumbnail`"
                />
              </td>
              <td style="vertical-align: middle">
                {{ item.id }}
              </td>
              <td
                style="vertical-align: middle"
                :class="{
                  'status-saleable': item.status == 'SALEABLE',
                  'blink_me status-on-sale': item.status == 'ON SALE',
                  'status-sold': item.status == 'SOLD',
                }"
              >
                {{ item.status }}
              </td>
              <td style="vertical-align: middle">{{ item.type }}</td>
              <td style="vertical-align: middle">{{ item.price }}</td>
              <td style="vertical-align: middle">
                <button
                  v-if="item.status === 'SALEABLE'"
                  type="button"
                  style="font-weight: bold"
                  class="btn btn-outline-primary"
                  @click="
                    selling(item.id, item.status, item.layout, item.price)
                  "
                >
                  SELL
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav v-if="totalPages > 1" aria-label="Ticket pagination">
          <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: pageSelected === 1 }">
              <button class="page-link" @click="handlePageChange(pageSelected - 1)">Prev</button>
            </li>
            <li
              v-for="p in totalPages"
              :key="p"
              class="page-item"
              :class="{ active: pageSelected === p }"
            >
              <button class="page-link" @click="handlePageChange(p)">{{ p }}</button>
            </li>
            <li class="page-item" :class="{ disabled: pageSelected === totalPages }">
              <button class="page-link" @click="handlePageChange(pageSelected + 1)">Next</button>
            </li>
          </ul>
        </nav>
      </div>
      <!-- Modal -->
      <div v-if="showModal" class="modal-backdrop-custom">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title"><b>Notification</b></h4>
            </div>
            <div class="modal-body">
              Received <b style="color: #ff9100">{{ ticketListSize }}</b> new
              ticket/s
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success"
                @click="refresh()"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import restService from '../services/RestService'
import WSServiceSyncTicket from '../services/WSServiceSyncTicket'
import WSServiceUpdateTicket from '../services/WSServiceUpdateTicket'
export default {
  name: 'ETHome',
  data() {
    return {
      myList: undefined,
      ticketListSize: 0,
      pageSelected: 1,
      ticketPerPage: 5,
      totalTickets: 0,
      showModal: false,
      isLoading: false,
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalTickets / this.ticketPerPage)
    },
  },
  methods: {
    selling: function (id, status, layout, price) {
      restService.sendQRCode(
        this.$route.params.retailId,
        id,
        status,
        layout,
        price,
      )
    },
    handlePageChange(value) {
      if (value < 1 || value > this.totalPages) return
      this.pageSelected = value
      this.retrieveTickets()
    },
    retrieveTickets() {
      this.isLoading = true
      restService
        .getTickets(
          this.$route.params.retailId,
          this.pageSelected,
          this.ticketPerPage,
        )
        .then((response) => {
          this.myList = response.data
          this.totalTickets = response.recordsTotal
          this.isLoading = false
        })
        // eslint-disable-next-line no-console
        .catch((e) => {
          console.log(e)
          this.isLoading = false
        })
    },
    refresh() {
      this.showModal = false
      document.location.href =
        '/ticket-list-legacy/' + this.$route.params.retailId
    },
  },
  async mounted() {
    let response = await restService.getTickets(
      this.$route.params.retailId,
      this.pageSelected,
      this.ticketPerPage,
    )
    this.myList = response.data
    this.totalTickets = response.recordsTotal
    WSServiceSyncTicket.connect((notification) => {
      var newTicketSize = JSON.parse(notification.body)
      this.ticketListSize = newTicketSize
      this.showModal = true
    }, this.$route.params.retailId)

    WSServiceUpdateTicket.connect((notification) => {
      var index = this.myList.findIndex(
        (item) => item.id === JSON.parse(notification.body).id,
      )
      var status = JSON.parse(notification.body).status
      if (index !== -1) {
        this.myList[index] = { ...this.myList[index], status }
      }
    }, this.$route.params.retailId)
  },
}
</script>
<style>
.status-saleable {
  color: #0368ab;
  font-weight: bold;
  font-style: italic;
}
.status-on-sale {
  color: #fbc408;
  font-weight: bold;
  font-style: italic;
}
.status-sold {
  color: #f3711d;
  font-weight: bold;
  font-style: italic;
}
.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.content {
  background-image: url('../img/logogev-sm.png');
  background-repeat: space;
  height: 100vh;
}
.modal-backdrop-custom {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
